module.exports = __webpack_public_path__ + "static/media/testing-fine-tune.1fd3f125.png";